import _ from 'lodash';

export class DataResponse {
  static transform(search) {
    return (response) => {
      return _.get(response, search);
    };
  }
}



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-response/src/dataResponse.js